<template>
  <div :class="classes" @mouseover="onArrow()" @mouseout="hideArrow()">
    <ol v-show="dots === 'none'? false:true" :class="dotsClasses">
      <template v-for="n in slides.length">
        <li :key="n.index" :class="[n - 1 === currentIndex ? 'active' : '']" @click="$_dotsEvent('click', n - 1)" @mouseover="$_dotsEvent('hover', n - 1)" />
      </template>
    </ol>
    <div :class="[`${prefixCarouselClass}-inner`]">
      <slot/>
    </div>
    <a v-show="showArrow" :class="`${prefixCarouselClass}-control-prev`" href="javascript:void(0);" role="button" data-slide="prev" @click="$_arrowEvent(-1)">
      <i :class="`${prefixCarouselClass}-control-prev-icon ${$constants.CLASS_MAIN} ${$constants.PREFIX_ICON_CLASS}chevron-left`" />
      <span class="sr-only">Previous</span>
    </a>
    <a v-show="showArrow" :class="`${prefixCarouselClass}-control-next`" href="javascript:void(0);" role="button" data-slide="next" @click="$_arrowEvent(1)">
      <i :class="`${prefixCarouselClass}-control-next-icon ${$constants.CLASS_MAIN} ${$constants.PREFIX_ICON_CLASS}chevron-right`" />
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import TIcon from '../icon/icon.vue'
const PREFIX_CAROUSEL_CLASS = `${PREFIX_CLASS}carousel`
export default {
  name: 'TaurusCarousel',
  components: { TIcon },
  props: {
    arrow: {
      type: String,
      default: 'hover',
      validator(value) {
        let validList = ['hover', 'always', 'never']
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    autoplaySpeed: {
      type: Number,
      default: 2000
    },
    easing: {
      type: String,
      default: 'ease'
    },
    dots: {
      type: String,
      default: 'inside',
      validator(value) {
        let validList = ['inside', 'none']
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
    },
    trigger: {
      type: String,
      default: 'click',
      validator(value) {
        let validList = ['click', 'hover']
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
    },
    value: {
      type: Number,
      default: 0
    },
    height: {
      type: [String, Number],
      default: 'auto',
      validator(value) {
        return (
          value === 'auto' ||
          Object.prototype.toString.call(value) === '[object Number]'
        )
      }
    }
  },
  data() {
    return {
      trackOffset: 0,
      slides: [],
      slideInstances: [],
      timer: null,
      ready: false,
      currentIndex: this.value,
      showArrow: this.arrow === 'always' // 控制箭头的显示和隐藏
    }
  },
  computed: {
    prefixCarouselClass() {
      return PREFIX_CAROUSEL_CLASS
    },
    classes() {
      return [`${PREFIX_CAROUSEL_CLASS}`]
    },
    arrowClasses() {
      return [
        `${PREFIX_CAROUSEL_CLASS}-arrow`,
        `${PREFIX_CAROUSEL_CLASS}-arrow-${this.arrow}`
      ]
    },
    dotsClasses() {
      return [`${PREFIX_CAROUSEL_CLASS}-indicators`]
    }
  },
  watch: {
    autoplay() {
      this.$_setAutoplay()
    },
    autoplaySpeed() {
      this.$_setAutoplay()
    },
    currentIndex(val, oldVal) {
      this.$emit('on-change', oldVal, val)
      this.$_updateOffset()
    },
    height() {
      this.$_updatePosition()
    },
    value(val) {
      this.currentIndex = val
    },
    arrow(val) {
      val === 'always' ? (this.showArrow = true) : (this.showArrow = false)
    }
  },
  mounted() {
    this.$_updateSlides(true)
    this.$_onResize()
    this.$_setAutoplay()
    window.addEventListener('resize', this.$_onResize, false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_onResize, false)
  },
  methods: {
    // 添加了一些私有方法
    // find option component
    $_findChild(cb) {
      const find = function(child) {
        const name = child.$options.componentName
        if (name) {
          cb(child)
          // 递归查找子组件
        } else if (child.$children.length) {
          child.$children.forEach(innerChild => {
            find(innerChild, cb)
          })
        }
      }
      if (this.slideInstances.length || !this.$children) {
        this.slideInstances.forEach(child => {
          find(child)
        })
      } else {
        this.$children.forEach(child => {
          find(child)
        })
      }
    },
    $_updateSlides(init) {
      let slides = []
      let index = 1
      this.$_findChild(child => {
        slides.push({
          $el: child.$el
        })
        child.index = index++
        if (init) {
          this.slideInstances.push(child)
        }
      })
      this.slides = slides
      this.$_updatePosition()
    },
    $_updatePosition() {
      this.$_findChild(child => {
        child.height =
          typeof this.height === 'number' ? `${this.height}px` : this.height
      })
    },
    // use when slot changed
    slotChange() {
      this.$nextTick(() => {
        this.slides = []
        this.slideInstances = []
        this.$_updateSlides(true, true)
        this.$_updatePosition()
        this.$_updateOffset()
      })
    },
    camelCase(name) {
      const SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g
      const MOZ_HACK_REGEXP = /^moz([A-Z])/
      return name
        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
          return offset ? letter.toUpperCase() : letter
        })
        .replace(MOZ_HACK_REGEXP, 'Moz$1')
    },
    getStyle(element, styleName) {
      if (!element || !styleName) return null
      styleName = this.camelCase(styleName)
      if (styleName === 'float') {
        styleName = 'cssFloat'
      }
      try {
        const computed = document.defaultView.getComputedStyle(element, '')
        return element.style[styleName] || computed ? computed[styleName] : null
      } catch (e) {
        return element.style[styleName]
      }
    },
    $_onResize() {
      this.$_updatePosition()
      this.$_updateOffset()
    },
    $_add(offset) {
      // offset表示移动的幻灯片的个数
      let index = this.currentIndex
      index += offset
      while (index < 0) index += this.slides.length
      index = index % this.slides.length
      this.currentIndex = index
      this.$emit('input', index)
    },
    $_arrowEvent(offset) {
      this.$_setAutoplay()
      this.$_add(offset)
    },
    $_dotsEvent(event, n) {
      if (event === this.trigger && this.currentIndex !== n) {
        this.currentIndex = n
        this.$emit('input', n)
        // Reset autoplay timer when trigger be activated
        this.$_setAutoplay()
      }
    },
    $_setAutoplay() {
      window.clearInterval(this.timer)
      if (this.autoplay) {
        this.timer = window.setInterval(() => {
          this.$_add(1)
        }, this.autoplaySpeed)
      }
    },
    $_updateOffset() {
      this.$nextTick(() => {
        this.modChildClass()
      })
    },
    modChildClass() {
      let i = 0
      this.$children.forEach(child => {
        if (i !== this.currentIndex) {
          child.$el.classList.remove('active')
        } else {
          child.$el.classList.add('active')
        }
        i++
      })
    },
    // 控制arrow显示或隐藏show
    onArrow() {
      if (this.arrow === 'hover') {
        this.showArrow = true
      }
    },
    hideArrow() {
      if (this.arrow === 'hover') {
        this.showArrow = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// carousel.vue?63468de1